import { useCallback } from 'react';

import { useContentTreeSelection } from '@confluence/content-tree-actions/entry-points/store.ts';

import { usePageTreeActions } from '../usePageTreeState.ts';

import { transformToPrimaryActionInput } from './data-transformers.ts';
import type { MutationOutputItem } from '@confluence/page-selection-table/entry-points/PageSelectionTable.ts';

// Primary actions include archive and delete
export const usePrimaryButtons = (): {
	getPrimaryActionInput: () => Error | MutationOutputItem[];
	getCurrentSpace: () => {
		spaceKey: any;
		spaceId: any;
	};
} => {
	const [{ selectedContent }] = useContentTreeSelection();

	const { getState } = usePageTreeActions();

	const getPrimaryActionInput = useCallback((): Error | MutationOutputItem[] => {
		const { rootId, pages, contentIdsWithLoadedChildren } = getState();

		const selectedContentCopy = { ...selectedContent };
		return transformToPrimaryActionInput(
			pages[rootId],
			pages,
			contentIdsWithLoadedChildren,
			selectedContentCopy,
		);
	}, [getState, selectedContent]);

	const getCurrentSpace = useCallback((): {
		spaceKey: any;
		spaceId: any;
	} => {
		const { spaceKey, spaceId } = getState();
		return { spaceKey, spaceId };
	}, [getState]);

	return {
		getPrimaryActionInput,
		getCurrentSpace,
	};
};
